export default __webpack_public_path__ + "static/media/tags.8bc440d2.png";